export const API_URL = import.meta.env.VITE_API_URL;
export const WS_URL = import.meta.env.VITE_API_URL;

export const RECAPTCHA_SITE_KEY = import.meta.env.VITE_APP_RECAPTCHA_SITE_KEY;

// # Google Authentication Popup
export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;
export const GOOGLE_REDIRECT_URI = import.meta.env.VITE_GOOGLE_REDIRECT_URI_DEV;
export const GOOGLE_SCOPES = import.meta.env.VITE_GOOGLE_SCOPES;

// # Microsoft Authentication Popup
export const MICROSOFT_CLIENT_ID = import.meta.env.VITE_MICROSOFT_CLIENT_ID;
export const MICROSOFT_SCOPES = import.meta.env.VITE_MICROSOFT_SCOPES;
export const MICROSOFT_TENANT_ID = import.meta.env.VITE_MICROSOFT_TENANT_ID;
export const MICROSOFT_REDIRECT_URl = import.meta.env.VITE_MICROSOFT_REDIRECT_URl_DEV;

// # sip connect for the pbx
export const SIP_SERVER_URL = import.meta.env.VITE_SIP_SERVER_URL_DEV;
export const SIP_CALL_DOMAIN = import.meta.env.VITE_SIP_CALL_DOMAIN_DEV;

// #  Whatsapp Authentication Popup
export const WHATSAPP_APP_ID = import.meta.env.VITE_WHATSAPP_APP_ID_DEV;
export const WHATSAPP_CONFIG_ID = import.meta.env.VITE_WHATSAPP_CONFIG_ID_DEV;
// # WhatsApp VoIP WebRTC TURN (optional — STUN is always used)
// export const TURN_URL = import.meta.env.VITE_WHATSAPP_TURN_URL_DEV;
// export const TURN_USERNAME = import.meta.env.VITE_WHATSAPP_TURN_USERNAME_DEV;
// export const TURN_CREDENTIAL = import.meta.env.VITE_WHATSAPP_TURN_CREDENTIAL_DEV;  

export const MOYASAR_PUBLIC_KEY = import.meta.env.VITE_MOYASAR_PUBLIC_KEY_DEV;

export const MESSENGER_APP_ID = import.meta.env.VITE_MESSENGER_APP_ID_DEV;
export const MESSENGER_APP_SCOPES = import.meta.env.VITE_MESSENGER_SCOPES_DEV;

// # Instagram
export const INSTAGRAM_APP_ID = import.meta.env.VITE_INSTAGRAM_APP_ID_DEV;
export const INSTAGRAM_SCOPES = import.meta.env.VITE_INSTAGRAM_SCOPES_DEV;